
import { PrintSendSetting, SaleConfig } from "@/models/dossier-configs/sale-config";
import { v4 } from "uuid";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			name: v4()
		};
	},
	props: {
		config: {
			required: true,
			type: Object as ()=>SaleConfig
		}
	},
	computed: {
		noneSelected():boolean {
			return this.config.PrintSendSetting == PrintSendSetting.Dont;
		},
		printAfterSendSelected():boolean {
			return this.config.PrintSendSetting == PrintSendSetting.PrintAfterSend;
		},
		sendAfterPrintSelected():boolean {
			return this.config.PrintSendSetting == PrintSendSetting.SendAfterPrint;
		}
	},
	methods: {
		selectNone(){
			this.config.PrintSendSetting = PrintSendSetting.Dont;
		},
		selectPrintAfterSend(){
			this.config.PrintSendSetting = PrintSendSetting.PrintAfterSend;
		},
		selectSendAfterPrint(){
			this.config.PrintSendSetting = PrintSendSetting.SendAfterPrint;
		}
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
